import React, { useState } from "react";
import "./notification.scss";
import { PopupHeaderText } from "../typographyText/TypographyText";
import { Button } from "devextreme-react";
import Tabs, { Item as TabItem } from "devextreme-react/tabs";
import NotificationItems from "./notification-item";
import NotificationAll from "./notification-all";
import { clearAllNotificationsApi } from "../../api/notificationApi";
import { useAuth } from "../../contexts/auth";

const TabsContent = ({
  setSelectedTab,
  countAllnotification,
  countnotification,
}) => {
  const [selectedTab1, setSelectedTab1] = useState(0);
  const onItemClick = (e) => {
    setSelectedTab(e.itemIndex);
    setSelectedTab1(e.itemIndex);
  };
  return (
    <div className="header-tab-section">
      <Tabs
        selectedIndex={selectedTab1}
        onItemClick={onItemClick}
        id="selectTab"
      >
        <TabItem text="Unread ">Unread </TabItem>
        <TabItem text="ALL">ALL</TabItem>
      </Tabs>
    </div>
  );
};

const NotificationMain = ({ closeHandler, companytransid }) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [refreshKey, setRefreshKey] = useState(0);
  const { user, setUnreadCount } = useAuth();

  const handleClearAll = async () => {
    try {
      const payload = {
        clearall: true,
        companytransid: user?.companytransid,
      };

      const res = await clearAllNotificationsApi(payload);

      //  Clear UI list
      setRefreshKey((prev) => prev + 1);

      //  IMMEDIATELY reset badge count
      setUnreadCount(0);
    } catch (error) {
      console.error("Error clearing notifications:", error);
    }
  };

  return (
    <>
      <div className="email-popup-header">
        <div className="email-text">
          <PopupHeaderText text="Notifications" />
        </div>
        <div className="header-actions">
          {" "}
          <Button
            text="Clear All"
            stylingMode="text"
            className="clear-all-btn"
            onClick={handleClearAll}
          />
          <div className="close-btn-section">
            <Button icon="close" onClick={closeHandler} />
          </div>
        </div>
        {/* <div className="close-btn-section">
          <Button icon="close" onClick={closeHandler} />
        </div> */}
      </div>
      <TabsContent setSelectedTab={setSelectedTab} />
      {selectedTab === 0 && <NotificationItems refreshKey={refreshKey} />}
      {selectedTab === 1 && <NotificationAll refreshKey={refreshKey} />}
    </>
  );
};

export default NotificationMain;
